import React, { useEffect } from 'react';
import { FormControl, Radio, RadioGroup } from 'ui-kit';
import { ENotificationChannel } from 'utils/notificationChannel';

import './NotificationChannelSwitcher.scss';

export interface INotificationChannelSwitcher {
  value: ENotificationChannel | null;
  onChange: (next: ENotificationChannel) => void;
  disabled?: boolean;
  smsSupported?: boolean;
  label?: string;
}

export const channelToFlags = (channel: ENotificationChannel | null) => ({
  isSmsEnabled: channel === ENotificationChannel.SMS,
  isWhatsappEnabled: channel === ENotificationChannel.WHATSAPP,
});

export const flagsToChannel = ({
  isSmsEnabled,
  isWhatsappEnabled,
}: {
  isSmsEnabled?: boolean;
  isWhatsappEnabled?: boolean;
}): ENotificationChannel | null => {
  if (isWhatsappEnabled) {
    return ENotificationChannel.WHATSAPP;
  }
  if (isSmsEnabled) {
    return ENotificationChannel.SMS;
  }

  return null;
};

const NotificationChannelSwitcher = ({
  value,
  onChange,
  disabled,
  smsSupported = true,
  label = 'Contact this person via:',
}: INotificationChannelSwitcher) => {
  useEffect(() => {
    if (!smsSupported && value === ENotificationChannel.SMS) {
      onChange(ENotificationChannel.WHATSAPP);
    }
  }, [smsSupported, value]);

  return (
    <FormControl
      className="NotificationChannelSwitcher"
      label={label}
      disabled={disabled}
      helperText={
        smsSupported ? undefined : 'Text messages are only available for US and Canada numbers.'
      }
    >
      <RadioGroup
        direction="horizontal"
        value={value ?? undefined}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        <Radio value={ENotificationChannel.SMS} disabled={disabled || !smsSupported}>
          Text message
        </Radio>
        <Radio value={ENotificationChannel.WHATSAPP}>WhatsApp</Radio>
      </RadioGroup>
    </FormControl>
  );
};

export default NotificationChannelSwitcher;
